import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
import { jsx as _jsx } from "react/jsx-runtime";
export var HiddenInput = /*#__PURE__*/React.forwardRef(function HiddenInput(props, ref) {
  return /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: clsx(styles['input'], props.className),
    "aria-hidden": true
  }));
});